/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./updatePolicy.defs.js";
export { main as default } from "./updatePolicy.defs.js";
